import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";

import { forwardRef, useEffect, useState } from "react";
import { renderFinalPrice } from "helpers/utils";

import {
    TextArea,
    ErrorMessage,
    TextAreaContainer,
    Count
} from "./PersonalMessage.styled";
import OptionWithValue from "../option/OptionWithValue";

const PersonalMessage = forwardRef(({ id, maxLength, price }, ref) => {
    const name = id
        ? `${id}.personalMessage.message`
        : "personalMessage.message";
    const checkedName = id
        ? `${id}.personalMessage.checked`
        : "personalMessage.checked";
    const priceFieldName = id
        ? `${id}.personalMessage.price`
        : "personalMessage.price";
    const quantityName = id ? `${id}.quantity` : "quantity";
    const skuName = id ? `${id}.sku` : "sku";
    const { register, watch, errors, setValue } = useFormContext();
    const personalMessage = watch(name);
    const watchFields = watch([name, quantityName, skuName]);
    const quantity = watch(quantityName);
    const count = maxLength - watchFields?.[name]?.length ?? 0;
    const personalMessagePrice = `(${renderFinalPrice(price, {
        canBeZero: true
    })})`;
    const [active, setActive] = useState(false);
    const HAS_QUANTITY = Number(quantity) > 0;
    const HAS_PRODUCTS_WITH_QUANTITY =
        personalMessage && personalMessage?.length > 0;
    const checked = HAS_QUANTITY && HAS_PRODUCTS_WITH_QUANTITY;

    useEffect(() => {
        if (checked) {
            setValue(checkedName, true);
        }
    }, [checked, checkedName, setValue]);

    return (
        <OptionWithValue
            id={checkedName}
            title={`Voeg een persoonlijke boodschap toe ${personalMessagePrice}`}
            active={active}
            setActive={setActive}
            disabled={
                watchFields[quantityName] <= 0 ||
                watchFields[skuName] === undefined
            }
            ref={ref}
        >
            <TextAreaContainer>
                <TextArea
                    name={name}
                    ref={register({
                        maxLength: {
                            value: maxLength,
                            message:
                                "Persoonlijke boodschap mag maximaal 160 characters bevatten."
                        }
                    })}
                    resize="none"
                    placeholder="Type jouw persoonlijke boodschap van maximaal 160 karakters"
                />
                <Count error={count < 0}>
                    {count || maxLength}/{maxLength}
                </Count>
            </TextAreaContainer>
            <ErrorMessage>
                {errors?.personalMessage?.message?.message}
            </ErrorMessage>
            <input
                name={priceFieldName}
                defaultValue={price}
                ref={register}
                hidden
            />
        </OptionWithValue>
    );
});

PersonalMessage.displayName = "PersonalMessage";

PersonalMessage.defaultProps = {
    maxLength: 160,
    price: undefined,
    id: undefined
};

PersonalMessage.propTypes = {
    maxLength: PropTypes.number,
    price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    id: PropTypes.string
};

export default PersonalMessage;
